import React, { useContext } from "react";
import AppRouter from "./AppRouter";
import AuthRouter from "./AuthRouter";
import { AuthContext } from "./AuthProvider";

function Routes() {
  const { user, loading } = useContext(AuthContext);
  return (
    <div>
      {loading ? (
        <div className="loader">
          <div className="justify-content-center jimu-primary-loading"></div>
        </div>
      ) : user ? (
        <AppRouter />
      ) : (
        <AuthRouter />
      )}
    </div>
  );
}

export default Routes;
